webpackJsonp([29184612147644],{

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/RaamdeoAgarwal.png";
	var icon2 = "https://winpeforum.com/assets/elements/VishalTulsiyan.png";
	var icon3 = "https://winpeforum.com/assets/elements/nupurgarg.png";
	
	var icon4 = "https://winpeforum.com/assets/elements/AishwaryaNagpal.png";
	var icon5 = "https://winpeforum.com/assets/elements/Bala_c_p.png";
	var icon6 = "https://winpeforum.com/assets/elements/DivyaMundra.png";
	var icon7 = "https://winpeforum.com/assets/elements/KarishmaMakhija.png";
	var icon8 = "https://winpeforum.com/assets/elements/LavanyaAshok.png";
	var icon9 = "https://winpeforum.com/assets/elements/ManasviniRaj.png";
	var icon10 = "https://winpeforum.com/assets/elements/NanikaKakkar.png";
	
	var icon11 = "https://winpeforum.com/assets/elements/NidhiGhuman.png";
	var icon12 = "https://winpeforum.com/assets/elements/NidhiSaraf.png";
	var icon13 = "https://winpeforum.com/assets/elements/PriyadarshiniRao.png";
	var icon14 = "https://winpeforum.com/assets/elements/RituVerma.png";
	var icon15 = "https://winpeforum.com/assets/elements/RochelleDSouza.png";
	var icon16 = "https://winpeforum.com/assets/elements/SwatiBhartia.png";
	var icon17 = "https://winpeforum.com/assets/elements/TanushreeAgarwal.png";
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/17oct2024/1.jpg";
	var I2 = "https://www.winpeforum.com/assets/sheshines/17oct2024/2.jpg";
	var I3 = "https://www.winpeforum.com/assets/sheshines/17oct2024/3.jpg";
	var I4 = "https://www.winpeforum.com/assets/sheshines/17oct2024/4.jpg";
	var I5 = "https://www.winpeforum.com/assets/sheshines/17oct2024/5.jpg";
	var I6 = "https://www.winpeforum.com/assets/sheshines/17oct2024/6.jpg";
	var I7 = "https://www.winpeforum.com/assets/sheshines/17oct2024/7.jpg";
	var I8 = "https://www.winpeforum.com/assets/sheshines/17oct2024/8.jpg";
	var I9 = "https://www.winpeforum.com/assets/sheshines/17oct2024/9.jpg";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/1.jpg";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/2.jpg";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/3.jpg";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/4.jpg";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/5.jpg";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/6.jpg";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/7.jpg";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/8.jpg";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17oct2024/9.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "Raamdeo Agrawal is the co-founder of Motilal Oswal Financial Services Limited (MOFSL) and one of India's most celebrated investors with more than three decades of investing experience. Under his leadership, MOFSL has emerged as a multi-location, multi-business financial services conglomerate. <br/><br/>\n  \n  He pioneered the equity research practice at MOFSL, the first by any Indian brokerage house, in the early 90s. Mr. Agrawal's 'value investing' philosophy enables him to pick high-potential small and midcap companies early that eventually become large caps. He drives the annual 'Wealth Creation Study' that has become a benchmark document analysing the top 100 wealth creating companies and decoding their success stories. Mr. Agrawal has also been instrumental in creating the Quality, Growth, Longevity and Price (QGLP) framework that forms the core investing philosophy of MOFSL and Motilal Oswal Private Equity.\n  <br/><br/>\n  Raamdeo is an Associate of The Institute of Chartered Accountants of India (ICAl and a member of the National Committee on Capital Markets of the Confederation of Indian Industry (CII). He has also featured on the 'Wizards of Dalal Street' on CNBC-TV18. In 1986, he co-authored, 'Corporate Numbers Game', with Mr. Ram K Piparia. He also authored 'The Art of Wealth Creation'.\n  \n  \n           ",
	      name: "Raamdeo Agarwal",
	      post: "<div>Chairman & Co-founder,<br/>Motilal Oswal Financial Services Ltd\n  \n          </div>"
	    }];
	    _this.Speaker3 = [{
	      imgUrl: icon2,
	      desc: "Vishal Tulsyan founded Motilal Oswal Private Equity in 2006 with MOFSL as its sponsor. He is directly involved in identifying businesses and supporting portfolio companies, and has built a platform to channelise long-term capital to create valuable enterprises and successful entrepreneurs. \n    <br/><br/>\n    Vishal spent over two decades in the Indian financial sector across private equity, investment banking and structured finance before co-founding Motilal Oswal Private Equity. He brings on board his deep experience of raising, investing and returning third-party capital across several economic cycles. He worked with Rabobank, helping build its corporate finance and investment banking franchise. He was also responsible for the origination and execution of structured finance, project finance, acquisition finance, private equity and M&A transactions. \n    <br/><br/>\n    He holds a Bachelor's degree in Commerce from the St. Xavier's College, Kolkata and is a member of The Institute of Chartered Accountants of India.\n    \n    \n            \n             ",
	      name: "Vishal Tulsiyan",
	      post: "<div>MD and CEO, <br/>MO Alternate Investment Advisors\n    \n            </div>"
	    }];
	    _this.Speaker4 = [{
	      imgUrl: icon3,
	      desc: "Nupur Garg is a leading investor in private equity and venture capital\nand an expert advisor to large institutional investors. She is the\nfounder of Winpe, an initiative to enhance gender diversity in the\ninvesting ecosystem.<br/><br/>\nNupur serves as Chairperson of the board of Kids Clinic India\nLimited (Cloudnine chain of hospitals) and an independent director\non the boards of Edelweiss Real Assets Managers Limited and\nMolbio Diagnostics Limited. She is an advisor to and a member of\nthe investment committee for the Dutch Good Growth Fund\n(DGGF) investment funds mandate given by the Dutch government\nfor investments in SMEs in frontier markets across 75 countries.<br/><br/>\nNupur has served two terms on the board of SIDBI, the Indian DFI,\nas an early member of the investment committee at the Fund of Funds managed by the National\nInvestment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government\nof India and on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for\ninvesting in the Indian start-up ecosystem; guiding the development of their investment programs. Nupur\nadvises select fund managers on a confidential basis on matters related to institutionalization, best practices\nand governance. She also mentors female entrepreneurs across various platforms.<br/><br/>\nNupur is recognized as a thought and industry leader with a list of recognitions that include the Private\nEquity International Most Influential Women (global) 2024, BW VC World Most Influential Women 2024,\n2023 and 2022, HerPower Award 2023, Forbes W-Power list of Self Made Women 2020, India\u2019s top 10\nWomen Leaders in Finance (AIWMI 2019), Vedica Women\u2019s Alliance\u2019s Women Leader in D&I 2022,\nWomen Empowerment Entrepreneur Award 2019-20 and the Business Excellence and Innovative Best\nPractices - Academia Award 2019.<br/><br/>\nIn her previous role, Nupur led the private equity and venture capital funds business in the region for IFC\nand is widely credited with establishing IFC\u2019s brand and credibility as one of the most respected\ninstitutional investors in this space. Under her stewardship, the portfolio doubled in size and returns,\nmoving from a negative IRR to delivering gains for the first time in its history.<br/><br/>\nNupur is a CA and an MBA from MIT Sloan School of Management, with executive education from\nHarvard Business School.<br/><br/>\nNupur loves to spend time with her mother, husband and 10-year-old son, travel to new places, read and\ndo 1500-piece puzzles.\n    \n             ",
	      name: "Nupur Garg",
	      post: "<div>Founder,<br/>Winpe\n            </div>"
	    }];
	    _this.Speaker2 = [{
	      imgUrl: icon4,
	      desc: "<div>\n      Aishwarya Nagpal is a Partner in the Corporate and Commercial practice group in the Mumbai office. She specialises in corporate and commercial transactions, including acquisitions, joint ventures, cross-border transactions, private equity investments, and routine advisory on all aspects of Indian corporate and foreign investment laws.\n<br/><br/>\nAishwarya advises private equity funds and other financial sponsors and their portfolio companies on a wide range of transactions, across a variety of sectors, including healthcare, IT & ITES, manufacturing, EdTech, logistics, real estate and financial services.\n\n        </div>",
	      name: "Aishwarya Nagpal",
	      post: "<div>Partner,<br/>Khaitan & Co\n\n        </div>"
	    }, {
	      imgUrl: icon5,
	      desc: " Bala C Deshpande is the Founder and Partner of MegaDelta Capital. Of her 30 years of experience Bala has two decades of investing experience. She started her investing career with ICICI Venture in 2001 and in 2008 she joined NEA to set up their India platform. Over the years, she has invested and backed many disruptive companies in the mid-market space. In October 2018, she along with two Partners founded an independent investment firm, MegaDelta Capital. Prior to her investing experience, Bala has had deep operating experience with reputed multi-national firms such as ICI, Cadbury\u2019s and BestFoods.\n<br/><br/>\nBala's investment career spans multiple sectors and she has played an instrumental role in many innovative plays and entrepreneurial journeys. These include the first Internet IPO, first 24-hour news channel, first Payment Tech company, several consumer companies that redefined the sector etc.\n<br/><br/>\nShe is a Board member of deeply disruptive companies like Info Edge Ltd., FSS, Greytip HR, MediSys Edutech, Panacea Medical Technologies, GOQii Inc etc. With her Board participation these companies have grown exponentially, emerged as category leaders and created immense shareholder value.\n<br/><br/>\nShe is passionate about Technology and its far-reaching implications on markets, businesses and consumers. She is keen to back entrepreneurs who redefine markets and create lasting economic value.\n\n\n         ",
	      name: "Bala C Deshpande",
	      post: "<div>Founder & Partner,<br/>\nMegaDelta Capital\n\n        </div>"
	    }, {
	      imgUrl: icon6,
	      desc: "Divya Mundra has 15 years of experience and specializes in Mergers & Acquisitions, Joint Ventures, General Corporate and Private Equity. Divya represents a range of domestic and international clients across various sectors, including agriculture, banking, fashion, healthcare, luxury goods, media, retail and technology.\n         ",
	      name: "Divya Mundra",
	      post: "<div>Senior Partner,<br/>AZB & Partners\n \n        </div>"
	    }, {
	      imgUrl: icon7,
	      desc: "<div>\n      Karishma joined MOPE in 2021. She is responsible for transaction evaluation, financial analysis, deal documentation and portfolio management.\n<br/><br/>\nPrior to joining Motilal Oswal Private Equity, Ms. Makhija had over 11 years of experience in Investment Banking (Spark Capital, IIFL, HDFC Bank & KPMG) across Private equity, M&A & Capital Market fund raises. During her career, she has successfully executed transactions, some of the notable ones include private equity transactions in TransUnion CIBIL, India Shelter Finance and EssKay Finance, acquisition of Micro Housing Finance by Svatantra Microfinance & IPO of AU Financiers.\n<br/><br/>\nMs. Makhija holds a Bachelor's Degree in Commerce from NM College of Commerce and Economics, Mumbai and is a member of the Institute of Chartered Accountants of India.\n\n\n  \n        \n        </div>",
	      name: "Karishma Makhija",
	      post: "<div>Senior Vice President,<br/>Motilal Oswal Alternates\n\n         \n        </div>"
	    }, {
	      imgUrl: icon8,
	      desc: "<div>\n    Lavanya brings deep life cycle growth equity investing experience to the firm. She has deployed funds, mentored portfolio companies through their journey and created healthy exit outcomes for investors in both India and the US. She joined Trifecta Capital to build out its late-stage equity platform, to consolidate its position as the financing partner for the new economy. She also cultivates a deep interest in fitness, yoga and mindfulness.<br/>\n<ul><li>15 years of growth equity investing and investment banking experience.</li>\n<li>Previously, M.D., Goldman Sachs Principal Investing, a senior member of a 12-person team deploying funds from GS\u2019 balance sheet and USD 8 Bn global private equity fund in India.</li>\n<li>Lifecycle investing experience including investments in Pepperfry, Azure, Cytecare and successful exits in Mahindra & Mahindra, Max India, and TVS Logistics.</li>\n<li>Also worked at SPO Partners, a value-investing oriented hedge fund in California managing USD 10 Bn, and Goldman Sachs investment banking in New York.</li></ul>\n \n        </div>",
	      name: "Lavanya Ashok",
	      post: "<div>Partner,<br/>Trifecta Capital\n \n        </div>"
	    }, {
	      imgUrl: icon9,
	      desc: "<div>\n      Manasvini has over 13 years of experience in advising private equity funds, large corporate conglomerates, lenders, multilateral institutions, export credit agencies, sponsors, investors, borrowers and contractors. With a specialization in project finance, structured finance, project development and M&A in the infrastructure and energy sectors, she has led high-value deals and cross-border transactions across Asia, Middle East, Australia and North America.\n<br/><br/>\nManasvini has worked at White & Case LLP. (New York office) for almost 2 years and also at International Finance Corporation (the World Bank Group) as part of their Asia Legal Team for 2 years.\n\n        \n        </div>",
	      name: "Manasvini Raj",
	      post: "<div>Partner,<br/>Cyril Amarchand Mangaldas\n        \n        </div>"
	    }, {
	      imgUrl: icon10,
	      desc: "<div>\n   \nNanika Kakkar serves as Partner at Cornerstone Venture Partners(India). She serves as Board Member at Karomi. She brings in 10+ years of investing experience across asset classes and stages. In her last role, she was managing International venture investing and portfolio management for Reliance Industries Limited, managing their funds in Israel and India, and investing in early and growth-stage emerging technologies.\n\n        </div>",
	      name: "Nanika Kakkar",
	      post: "<div> Partner,<br/>Cornerstone Venture Partners Fund\n \n        </div>"
	    }, {
	      imgUrl: icon11,
	      desc: "<div>\n    Nidhi Ghuman is the Founder of Vincer\xE9 Partners. Prior to this, she was Fund Manager with 360 ONE Asset AMC\u2019s private equity team. In this role, she leads investments for IIFL\u2019s growth equity & pre-IPO private equity funds. She has also worked as a Principal at Multiples Private Equity where she invested across growth, buyout and turnaround situations in businesses in healthcare, pharma and business services sectors. She started her career with SBI Capital Markets and GE Capital where she advised companies on equity and debt fund raising, M&A, and debt restructuring. She holds a MBA from XLRI Jamshedpur and B.Tech from IIT Madras.\n\n  \n        \n        </div>",
	      name: "Nidhi Ghuman",
	      post: "<div>Founder,<br/>Vincer\xE9 Partners\n\n\n         \n        </div>"
	    }, {
	      imgUrl: icon12,
	      desc: "<div>\n     Nidhi\u2019s career spans the startup ecosystem way back in 2009, a startup evangelist, she has been the first employee of Mumbai Angels and started her journey when startup ecosystem was new to India.\n<br/><Br/>\nWorked with leading angel networks in the country like Indian Angel Network(IAN), Intellecap Impact Investment Network (I3N) and Mumbai Angels while working with Portfolio companies of Mumbai Angels\u2013Wild East Group. Working with KKR, Yash Raj Films, Dr. Seuss amongst the few was an experience which can\u2019t be defined. An angel investor in few start-ups ay her individual capacity while mentoring a few. After the stint with the angel groups, the entrepreneurial bug bit her to start a new journey for herself, as an entrepreneur. Being a part of this dynamic ecosystem that is meant to happen. Key Venture, raises funds for Seed, Angel and Series A, B investments for both Equity and Debt, largely focused in India. It has individual and institutional investors spread globally.  Key Venture works very closely with large corporations to leverage their ability in the start-up ecosystem.\n\n\n        </div>",
	      name: "Nidhi Saraf",
	      post: "<div>Founder & CEO,<br/>Key Venture\n\n        </div>"
	    }, {
	      imgUrl: icon13,
	      desc: "<div>\n    I am an India qualified Capital Markets lawyer, based out of Mumbai. I have been recognized by the Legal500, IFLR1000 (Rising Star Partner - Capital Markets) and AsiaLaw (Rising Star - Capital Markets), and shortlisted as a Lawyer of the Year (Equity Capital Markets) by Women in Business Law Awards 2023 APAC.\n<br/><br/>\nI have advised a wide range of clients across sectors such as NATCs, manufacturing, retail/wholesale, QSR, BFSI (banks, MFI, insurance), energy etc., on initial public offerings, qualified institutions placements, rights issues, offers for sale and foreign debt issuances, from the perspective of Indian law. On these transactions, I have advised the issuers, merchant bankers and more recently private equity funds as selling shareholders.\n<br/><br/>\nOther than transactional practice, I have also helped my listed clients and merchant banking clients periodically with their ongoing securities law obligations.\n<br/><br/>\nIn my free time I enjoy travelling, being outdoors and meeting new people.\n\n  \n        \n        </div>",
	      name: "Priyadarshini Rao",
	      post: "<div>Partner,<br/>Induslaw\n\n\n         \n        </div>"
	    }, {
	      imgUrl: icon14,
	      desc: "<div>\n    Ritu Verma is the co-founder and Managing Partner at Ankur Capital \u2013 an early stage venture capital firm that invests in disruptive digital and science led technologies. She is passionate about supporting breakthrough ideas that can solve challenging problems and create a better world. She has sat on the sides of many category creating companies as they establish roots and scale across the globe over the past 10 years. Ritu sits on the board/board observer positions at multiple of Ankur\u2019s portfolio \u2013 Cropin, Niramai, StringBio, Vegrow, Krishify, Piatrika, OffGrid, IBISA, Superfone and BigHaat. \n<Br/><Br/>\nPrior to starting Ankur Capital, Ritu ran Truven an advisory firm for venture funds looking at investments in India and SE Asia. One of the funds she worked with was BASF corporate venture fund, which focused on investments in renewable energy, agri-biotech and materials. She has also brought products from lab to market across the globe as parts of innovation teams in Unilever and Philips working across roles from product development to marketing strategy. She holds 7 patents and has authored and contributed to seven peer reviewed research publications in prestigious journals. Ritu is a director and a member of the steering committee at ThinkAg a non-profit platform for scaling ag-tech innovations in India. She is a member of the Global Development Committee for American Society of Mechanical Engineers that focuses on hardware innovations globally. She is also a member of the Core Advisory Committee for the Centre of Excellence in Agri Innovation at C-CAMP and IKP Advisory Group for our Agri and Sustainability. She has also been part of government led initiatives to drive agricultural growth and sustainability. She holds an MBA from INSEAD and a Ph.D. in physics from the University of Pennsylvania and has bachelors from Middlebury College, Vermont.\n\n        \n        </div>",
	      name: "Ritu Verma",
	      post: "<div>Managing Partner,<Br/>\nAnkur Capital\n\n\n         \n        </div>"
	    }, {
	      imgUrl: icon15,
	      desc: "<div>\n   Rochelle D\u2019Souza is a managing director at Lighthouse Advisors, a leading mid-market, private equity investment firm. She co-leads the investment team and specializes in food, healthcare and agri sectors. Ms. D\u2019Souza\u2019s current board positions include Tynor Orthotics, the largest orthotics soft good company in India, Wow! Momo Foods, which is India\u2019s largest homegrown QSR brand, and V2 Retail, a leading value retailer. In her personal time, she serves as a mentor for the YEA Academy and is also an ambassador for WinPE, the network for women in private equity. She was Ranked among the Top 100 Women inFinance by AIWMI in 2019; Ms. D\u2019Souza received her MBA from the SP Jain School of Management and holds a Bachelor in Engineering in Electronics from RVCE.\n \n        </div>",
	      name: "Rochelle D’Souza",
	      post: "<div>MD,<br/>Lighthouse\n    \n        </div>"
	    }, {
	      imgUrl: icon16,
	      desc: "<div>\n     Swati Bhartia is a Principal at Motilal Oswal Private Equity. She has more than 15 years of experience in managing PE investments and equity research. Before joining MOPE, she worked with Tata Capital Healthcare Fund (TCHF) for nine years. During her stint with TCHF, Swati was involved in end to end deal management and successfully deployed USD 100+ Mn. Prior to that, she worked with Oman India Joint Investment Fund (OlJIF), where she was involved in deal evaluation across diverse sectors such as healthcare, machine tools, auto ancillaries, specialty chemicals and pharmaceuticals. She started her career with Crisil as equity Research Analyst in 2005, covering European mid & large-cap Biotech companies.\n<br/><Br/>\nSwati is a 37th All India rank-holder Chartered Accountant and a CFA charter-holder. She is a part of Bloomberg's Women Buy-side Network (India) and featured as Top 40 Alternate Investment Professionals in India by AlWMI.\n \n        </div>",
	      name: "Swati Bhartia",
	      post: "<div>Director,<br/>Motilal Oswal Private Equity\n\n        </div>"
	    }, {
	      imgUrl: icon17,
	      desc: "<div>\n  Tanushree is an investment professional with 14 years of experience in private equity and project finance over diverse sectors such as real estate, infrastructure, and allied sectors. At Sabre, she is responsible for deal sourcing, evaluation of potential investment opportunities and managing investments in financial services, healthcare, and climate change sectors.\n<br/><Br/>\nPrior to Sabre, Tanushree has spent the past 8 years working with the commercial and residential funds of Edelweiss Alternate Asset Advisors and Milestone Capital Advisors. Apart from managing the entire deal life cycle, she was also involved in fund-raising by way of conceptualizing the fund strategy and formulating the marketing and fund documents She has managed over INR 7.5 billion assets across six different funds being involved in end-to-end fund lifecycle. Prior to this she was a part of the Infrastructure Banking/Project Finance team at Yes Bank for 4 years.\n<br/><Br/>\nTanushree holds an MBA in finance from Faculty of Management Studies, Delhi, and has also cleared all three levels of CFA (USA). She is a B.E. in Computer Engineering from Sardar Patel College of Engineering (Mumbai University).\n\n  \n        \n        </div>",
	      name: "Tanushree Agarwal",
	      post: "<div>Partner,<br/>Sabre Partners\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 27, ImgSrc: I2, ImgSrc1: II2 }, { id: 62, ImgSrc: I3, ImgSrc1: II3 }, { id: 28, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 22, ImgSrc: I6, ImgSrc1: II6 }, { id: 19, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 34, ImgSrc: I9, ImgSrc1: II9 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "sheshines with Winpe "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "October 17, 2024 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Motilal Oswal Tower, Prabhadevi, Mumbai "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "h4",
	                null,
	                "Hosted by: Motilal Oswal"
	              )
	            ),
	            " ",
	            _react2.default.createElement("br", null),
	            "  ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text" },
	              "The Winpe sheshines event, hosted by Motilal Oswal in Mumbai on October 17, 2024, was a resounding success. The evening\u2019s theme was ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "\"How Investors Add Value to Investee Companies,\""
	              ),
	              " which brought together a distinguished group of investment professionals for an insightful and engaging discussion. ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The highlight of the event was the fireside chat with Raamdeo Agarwal, Chairman & Co-founder of Motilal Oswal Financial Services Ltd. and Vishal Tulsiyan, MD & CEO of MO Alternates who shared strategic insights on how long term investors can harness the power of compounding and a compelling discussion underscoring the business advantages of gender diverse teams. The conversation was moderated by Nupur Garg, founder of Winpe.  ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The roundtable discussions focused on sustaining long-term growth, emphasising on value creation for shareholders and stakeholders via strategic guidance, operational expertise, and networks to help companies scale, while enhancing governance and offering capital for expansion. The exciting format catalyzed cross learnings across strategies and stages and the atmosphere was charged with intellectual energy, as participants engaged in vibrant discussions and posed thought-provoking questions. So much so that Winpe announced that it would offer the WLSA giveaways for all questions asked rather than to the best 4.  ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The evening concluded with lots of networking over snacks and beverages, leaving attendees looking forward to future Winpe events. With discussions like these, Winpe sheshines is steadily advancing the visibility and influence of women in investing."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "gallery/" },
	                _react2.default.createElement(
	                  "button",
	                  { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                  "View All Images"
	                ),
	                " "
	              ),
	              " "
	            ),
	            _react2.default.createElement(
	              "h2",
	              { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	              "Speakers"
	            ),
	            "          ",
	            _react2.default.createElement("div", { "class": "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text" },
	              _react2.default.createElement(
	                "p",
	                null,
	                "The esteemed lineup of speakers included Aishwarya Nagpal, Partner at Khaitan & Co, Divya Mundra, Senior Partner at AZB & Partners, Karishma Makhija, Senior Vice President at MOPE Investment Advisors Pvt. Ltd., Lavanya Ashok, Partner at Trifecta Capital, Manasvini Raj, Partner at Cyril Amarchand Mangaldas, Nanika Kakkar, Partner at Cornerstone Venture Partners Fund, Nidhi Ghuman, Founder of Vincere, Nidhi Saraf, Founder & CEO of Key Venture, Priyadarshini Rao, Partner at Induslaw, Ritu Verma, Managing Partner at Ankur Capital, Rochelle Dsouza, MD at Lighthouse, and Tanushree Agarwal, Partner at Sabre Partners. "
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row", style: { width: '60%', marginLeft: '20%' } },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "25px", textAlign: 'center' } },
	                    "Special Invitee"
	                  ),
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '100%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "25px", textAlign: 'center' } },
	                    "In the Hot Seat"
	                  ),
	                  "   ",
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '100%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker3.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "25px", textAlign: 'center' } },
	                    "Moderator"
	                  ),
	                  "      ",
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '100%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker4.map(function (item, i) {
	
	                          return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "Our_Speakers container" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "25px", textAlign: 'center' } },
	                  "Industry Roundtable"
	                ),
	                "           ",
	                _react2.default.createElement(
	                  "center",
	                  null,
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Speakers_img", style: { width: '75%' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      this.Speaker2.map(function (item, i) {
	
	                        return _react2.default.createElement(
	                          "div",
	                          {
	                            className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                            key: i
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "Scardd" },
	                            _react2.default.createElement(
	                              "div",
	                              {
	                                className: "s_img",
	                                onClick: function onClick() {
	                                  return _this3.togglePopUp(item);
	                                }
	                              },
	                              _react2.default.createElement(
	                                "center",
	                                null,
	                                "  ",
	                                _react2.default.createElement("img", {
	                                  src: item.imgUrl,
	                                  alt: item.name,
	                                  className: "img-responsive",
	                                  style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                })
	                              )
	                            ),
	                            _react2.default.createElement("br", null),
	                            "    ",
	                            _react2.default.createElement("div", {
	                              className: "Speakers_name",
	                              dangerouslySetInnerHTML: { __html: item.name }
	                            }),
	                            _react2.default.createElement("div", {
	                              className: "Speakers_post",
	                              dangerouslySetInnerHTML: { __html: item.post }
	                            })
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-she-shines-17-oct-2024-index-js-791e2ed113cea3c43dda.js